import { isIgnoreAuthPath } from '~/utils/route'

const checkRedirectRoute = (route, app) => {
  const ignoreAuthRoute = isIgnoreAuthPath(route.path)
  const hasToken = !!app.$apolloHelpers.getToken()

  // if (!hasToken && !ignoreAuthRoute) {
  //   return `/signin?from=${route.fullPath}`
  // }

  // if (route.path.startsWith('/course-detail/')) {
  //   return `/academy${route.path}`
  // }

  return ''
}

export default async function ({ app, redirect, route }) {
  const redirectPath = checkRedirectRoute(route, app)
  if (redirectPath) {
    return redirect(redirectPath)
  }
}
